interface Props {
  items: string[];
}

export function HomeTechStack({ items }: Props) {
  if (!items || items.length === 0) return null;
  // Duplicate for seamless marquee loop
  const loop = [...items, ...items];
  return (
    <section className="border-y border-border py-8">
      <div className="container-default">
        <p className="text-center text-xs font-semibold uppercase tracking-[0.2em] text-fg-subtle">
          Built with
        </p>
        <div className="mt-6 overflow-hidden">
          <div
            className="flex w-max animate-marquee gap-12 text-sm font-medium text-fg-muted motion-reduce:animate-none"
            style={{ minWidth: '100%' }}
          >
            {loop.map((item, i) => (
              <span key={`${item}-${i}`} className="whitespace-nowrap">
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}